import React from "react";
import ReactDOM from "react-dom/client";
import ResourceTimeline from "../components/resourceTimeline";
import { QueryClient, QueryClientProvider } from "react-query";

export default () => {
  const element = document.getElementById("resource-timeline-root");
  if (!element) return;
  if (!element.dataset.customerid) return;
  if (!element.dataset.resourceid) return;
  if (!element.dataset.basepath) return;

  const queryClient = new QueryClient();

  ReactDOM.createRoot(element).render(
    <QueryClientProvider client={queryClient}>
      <ResourceTimeline
        customerId={element.dataset.customerid}
        resourceId={element.dataset.resourceid}
        basePath={element.dataset.basepath}
      />
    </QueryClientProvider>,
  );
};
